module.exports = __webpack_public_path__ + "media/images/icon__dropdown--arrow@3x-dcee7d7be2fa48eff169b663def6084f.png";